import { getStore } from '~/mobx/AppStore';
import getSelectedElectionUpdateAttributes from './getSelectedElectionUpdateAttributes';

const handleChangeElectionAttribute = (key: string, value: string) => {
    const { generalSettingsStore } = getStore();
    const { companyElectionData, setCompanyElectionData } = generalSettingsStore;
    const attributesToUpdate = getSelectedElectionUpdateAttributes([...companyElectionData], key, value);
    setCompanyElectionData(attributesToUpdate);
};

export default handleChangeElectionAttribute;
